/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateScanSummary {
    getFixupPrototypeFunction() { return TemplateScanSummary.fixupPrototype; }

    static newInstance(model: Partial<TemplateScanSummary>): TemplateScanSummary {
        let obj = Object.assign(new TemplateScanSummary(), model);
        TemplateScanSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateScanSummary>): TemplateScanSummary {
        if (!model) return null;
        return TemplateScanSummary.newInstance(<TemplateScanSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateScanSummary) {
        if (!obj) return;

        models.TemplateScanSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateScanSummary): boolean {
        Object.setPrototypeOf(obj, TemplateScanSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total === undefined) {
            this.total = 0;
        }
        if (this.passed === undefined) {
            this.passed = 0;
        }
        if (this.failed === undefined) {
            this.failed = 0;
        }
        if (this.parsing_errors === undefined) {
            this.parsing_errors = 0;
        }
        if (this.skipped === undefined) {
            this.skipped = 0;
        }
    }

    /**
     * Total number of checks evaluated
     */
    total: number;

    /**
     * Number of checks that passed
     */
    passed: number;

    /**
     * Number of checks that failed
     */
    failed: number;

    /**
     * Number of checks that could not be evaluated due to parsing errors
     */
    parsing_errors: number;

    /**
     * Number of checks skipped
     */
    skipped: number;

}
